import type BundlePackage from '@itinerary/bundle/BundlePackage';
import { useHandleEvents } from '@composable/_local/hotel&view/useHandleEvents';

export function useReserve() {
    const bundleModule = useBundleModule();
    const bundleForm = useBundleForm();
    const router = useRouter();
    const handleEvents = useHandleEvents;
    const reserveBundle = (pkg: BundlePackage, index: number) => {
        bundleModule.selectBundlePackage(pkg);
        handleEvents(pkg, index);
        router.push(bundleForm.residencePageUrl);
    };
    return { reserveBundle };
}
